'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasicClass = function () {
    function BasicClass(_dom) {
        _classCallCheck(this, BasicClass);

        this.dom = _dom;
        this.form = null;
        this.settings = {};
    }

    _createClass(BasicClass, [{
        key: 'isExists',
        value: function isExists() {
            //TODO Check if not funcion
            if (this.dom === null) {
                return false;
            }

            console.log('this.dom.length', this.dom.length);
            return this.dom.length == 1;
        }
    }, {
        key: 'isFormExists',
        value: function isFormExists() {
            if (this.form === null) {
                return false;
            }

            return this.form.length == 1;
        }

        /** Interfaces */

    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {};
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            return true;
        }

        /**
         * Detect obj exists 
         * 
         * @param {*} obj 
         * @returns 
         */

    }, {
        key: 'objExists',
        value: function objExists(obj) {
            return obj.length > 0;
        }
    }]);

    return BasicClass;
}();
'use strict';

/**
 * This file contains all helper
 */
window.Colesel = window.Colesel || {};

/**
 * Check Elememtn visible in Viewport
 * 
 * @param {integer} offsetTopElementTop 
 * @returns 
 */
Colesel.isInViewport = function () {
    var offsetTopElementTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


    var elementTop = $(this).offset().top + offsetTopElementTop;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

/**
 * Generate random string 
 * @param {integer}} lenghth 
 * @returns 
 */
Colesel.generateString = function () {
    var lenghth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

Colesel.isAdmin = function () {
    var isCustomizing = false;

    if (window.location !== window.parent.location) {
        isCustomizing = true;
    }

    return isCustomizing;
};

Colesel.getUrlVars = function () {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }

    return vars;
};

/**
 * Verifica se sono in un dispositivo mobile
 * * Se "useUseAgent" == false controllo solo la width della finestra
 * @param {number} width
 * @param {boolean} useUseAgent
 */
Colesel.isMobile = function (width) {
    var useUseAgent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var isMobile = false;

    if (useUseAgent == true) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width() <= width) {
            isMobile = true;
        }
    } else if ($(window).width() <= width) {
        isMobile = true;
    }

    return isMobile;
};

/**
 * Verifica se la finestra è minore del valore "width"
 * @param {number} width
 */
Colesel.widthMinusFrom = function (width) {
    return $(window).width() <= width;
};

/**
 * Detect str is Json
 */
Colesel.isJson = function (str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        console.warn('NOT JSON', e);
        return false;
    }
};

/***********************************
 * 
 *  HELPER VALIDATION FORM INPUT FIELDS
 */
Colesel.validateForm = {};

/**
 * Aggiunge la classe errore all'oggetto obj
 * @param {*} obj
 */
Colesel.validateForm.errorShow = function (obj) {
    var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var objError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    obj.addClass(Colesel.costants.cssInputClassError);
    if (objError !== null) {
        if (msg !== null) {
            objError.text(msg);
        }
        objError.removeClass(Colesel.costants.cssHideClass);
    } else {
        if (msg !== null) {
            obj.next().text(msg);
        }
        obj.next().removeClass(Colesel.costants.cssHideClass);
    }
};

/**
 * Nasconde l'errore
 */
Colesel.validateForm.errorHide = function (obj) {
    var objError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    obj.removeClass(Colesel.costants.cssInputClassError);
    if (objError !== null) {
        objError.addClass(Colesel.costants.cssHideClass);
    } else {
        obj.next().addClass(Colesel.costants.cssHideClass);
    }
};

/**
 * Validate cehckbox
 * 
 * @param {*} oobjCheckboxbj 
 * @returns json
 */
Colesel.validateForm.inputChecked = function (objCheckbox) {
    var objError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var validated = false;
    if (objCheckbox.prop("checked") === true) {
        validated = true;
    }

    return { 'validated': validated, 'msg': null };
};

/**
 * Validate Email address
 * 
 * @param {string} email 
 * @returns json
 */
Colesel.validateForm.validateInputRequired = function (_input) {
    var input = _input.val();
    var validated = true;
    var errMsg = null;

    if (input.trim() === "") {
        validated = false;
        errMsg = Colesel.strings.general.form_validate.label.compile_field;
    }

    return { 'validated': validated, 'msg': errMsg };
};

/**
 * Validate Email address
 * 
 * @param {string} email 
 * @returns json
 */
Colesel.validateForm.validateEmail = function (_email) {
    var email = _email.val();
    var validated = true;
    var errMsg = null;

    if (email.trim() === "") {
        validated = false;
        errMsg = Colesel.strings.general.form_validate.label.compile_field;
    } else if (!/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(email)) {
        validated = false;
        errMsg = Colesel.strings.general.form_validate.label.email_error;
    }

    return { 'validated': validated, 'msg': errMsg };
};

Colesel.extend = function () {
    for (var i = 1; i < arguments.length; i++) {
        for (var key in arguments[i]) {
            if (arguments[i].hasOwnProperty(key)) arguments[0][key] = arguments[i][key];
        }
    }return arguments[0];
};

/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
Colesel.simulateClick = function (elem) {
    var _eventInitDict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Create our event (with options)
    var eventInitDict = Colesel.extend({
        bubbles: true,
        cancelable: true,
        view: window
    }, _eventInitDict);
    var evt = new MouseEvent('click', eventInitDict);
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
};

/**
 * Getting the next element that matches a selector
 * if a selector isn’t provided, return the first nextElementSibling.
 */
Colesel.Next = function (elem, selector) {

    // Get the next sibling element
    var sibling = elem.nextElementSibling;

    // If there's no selector, return the first sibling
    if (!selector) return sibling;

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }
};